export default {
  slug: "could-your-family-find-what-they-need",
  title: "Could Your Family Find What They Need?",
  date: "2026-08-25",
  author: "About U",
  cover: "/images/blog/family-information.webp",
  coverAlt: "A couple reading through documents with an adviser",
  body: `
Most of us take steps to protect our families through life cover, medical aid, investments, and estate planning.

But there's one question that's often overlooked:

If something happened to you tomorrow, would your family know where to find the information they need?

In times of crisis, even simple details can become difficult to locate. Important contact numbers, policy information, medical aid details, and estate planning documents are often spread across emails, filing cabinets, online portals, and desk drawers.

The result? Unnecessary stress and confusion during an already emotional time.

Taking a few moments to organise your financial and personal information can make a significant difference for those you leave behind. It doesn't have to be complicated. Start by making a list of key information and ensuring a trusted family member knows where it can be found.

Consider keeping the following information up to date:

- Insurance and funeral policy details
- Medical aid information
- Financial adviser contact details
- Emergency contacts
- Banking and investment information
- Details relating to your Will and estate planning

Being organised isn't about expecting the worst. It's about making life a little easier for the people who matter most.

Need help reviewing your cover or ensuring your financial affairs are in order? We're here to help.

Peace of mind starts with being prepared.

The aboutU family
`,
};
